export default {"src":"/_next/static/image/public/images/ic_chat.2ee00ca072f83e249690aa6b0de5a298.svg","height":52,"width":52};